import React from 'react'
import HeadNav from '../../head-nav/head-nav'
import HeadNavLink from '../../head-nav/head-nav-link/head-nav-link'

const Nav = ({ classes, className }) => (
  <HeadNav>
    <HeadNavLink path="/groups">Groups</HeadNavLink>
    <HeadNavLink path="/">Pupils</HeadNavLink>
  </HeadNav>
)

export default Nav
